module.exports = __webpack_public_path__ + "img/21.316a7c92.png";